module.exports = __webpack_public_path__ + "static/media/exp.95162435.jpg";